<RepairDetailSearch headerTextOther="Other Event / Repair" detailsType="other" AddUrl="ORepairs/Repairs/RepairDetail">
